import {createRouter, createWebHistory} from 'vue-router'

const Layout = () => import('../views/layout/index.vue')
const routes = [
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '',
                meta: {
                    title: '',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/index/index')
            },
        ]
    },
    {
        path: '/qrcode',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '二维码列表',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/qrcode/list.vue')
            },
            {
                path: 'create',
                meta: {
                    title: '生成二维码',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/qrcode/create.vue')
            }
        ]
    },
    {
        path: '/product',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '产品列表',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/product/list.vue')
            }
        ]
    },
    {
        path: '/info',
        component: Layout,
        children: [
            {
                path: 'info',
                meta: {
                    title: '公司信息',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/info/info.vue')
            }
        ]
    },
    {
        path: '/operator',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '操作员列表',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/operator/list.vue')
            }
        ]
    },
    {
        path: '/login',
        meta: {
            title: '登录'
        },
        component: () => import(/* webpackChunkName:'second' */ '../views/index/login')
    },
    /* 本段代码放在最后，未设置路由的地址跳转404 */
    {
        path: '/:catchAll(.*)',
        redirect: '/404'
    },
    {
        path: '/404',
        component: Layout,
        children: [
            {
                path: '',
                meta: {
                    title: '页面不存在'
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/404')
            },
        ]
    },
    /** 本段代码放在最后，未设置路由的地址跳转404 */
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
